import React from 'react';
import PropTypes from 'prop-types';
import request from '../../utils/agent';
import Loader from 'components/Loader';
import DatePickerComponent from "components/DatePickerComponent";
import FormattedNumInput from 'components/FormattedNumInput';
import { Formik, Field, FieldArray, Form } from 'formik';
import * as Yup from 'yup';



export default class DevArchProfile extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            userD: { },
            companyD: { },
            cData: { },
            operationRad: { },
            userLoaded: false,
            compLoaded: false,
            cDataLoaded: false,
            updateFlag: false,
            editingProfile: false,
            isError: false,
            geo: null,
            lat: null,
            long: null,
            address_status: "",
            address: "",
            city: "",
            postal: "",
            country: "",
            state: "",
            touched: {
                address: false,
                city: false,
                postal: false,
                country: false,
                state: false,
            }
        };
    }

    editProfile = () => {
        this.setState({editingProfile: !this.state.editingProfile});
    };

    componentDidMount() {
        this.getUserData();
        this.getCompanyData();
        this.getcData();
    }

    componentDidUpdate() {
        if(this.state.updateFlag === true) {
            this.getUserData();
            this.getCompanyData();
            this.getcData();
            this.setState({
                updateFlag: false,
                editingProfile: false
            });
        }
        if(this.state.editingProfile === true) {
            this.addressListener();
        }
    }

    addressListener = (setFieldValue) => {
        const autocompleteFormField = document.getElementById(`addressAutocomplete.street`);

        const autocomplete = new google.maps.places.Autocomplete((autocompleteFormField), {
            types: [`address`]
        });

        google.maps.event.addListener(autocomplete, `place_changed`, () => {
            const place = autocomplete.getPlace();
            let ac = place.address_components;
            var address = {
                country: ac.filter(c => ~c.types.indexOf('country'))[0].short_name,
                street: place.name,
                city: ac.filter(c => ~c.types.indexOf('locality'))[0].long_name,
                state: ac.filter(c => ~c.types.indexOf('administrative_area_level_1'))[0].short_name,
                postal: ac.filter(c => ~c.types.indexOf('postal_code'))[0].short_name
            };

            //console.log(address); // This is our address selected component

            // I don't know how you would pass these to Formik.
            for(let key in address) {
                try {
                    document.getElementById(`addressAutocomplete.${key}`).value = address[key];
                    this.setState({
                        address: address.street,
                        city: address.city,
                        postal: address.postal,
                        country: address.country,
                        state: address.state,
                    })
                } catch(e) {
                    console.log(`Unable to set addressAutocomplete.${key}:${address[key]}`);
                }
            }

        });
    };

    handleAdrChange = (e) => {
        e.preventDefault();
        this.setState({
            address: e.target.value,
        })
    };
    handleCountryChange = (e) => {
        e.preventDefault();
        this.setState({
            country: e.target.value,
        })
    };
    handleCityChange = (e) => {
        e.preventDefault();
        this.setState({
            city: e.target.value,
        })
    };
    handleStateChange = (e) => {
        e.preventDefault();
        this.setState({
            state: e.target.value,
        })
    };
    handlePostalChange = (e) => {
        e.preventDefault();
        this.setState({
            postal: e.target.value,
        })
    };

    handleAdrBlur = (fieldName) => (e) => {
        this.setState({
            touched: {
                ...this.state.touched, [fieldName]: true
            },
        })
    };

    validateAdr(address, city, state, postal, country){
        return {
            address: address.length === 0,
            city: city.length === 0,
            state: state.length === 0,
            postal: postal.length === 0,
            country: country.length === 0,
        };
    };

    handleSubmitErr(e) {
        e.preventDefault();
        this.setState({
            touched: {
                address: true,
                city: true,
                postal: true,
                country: true,
                state: true,
            }
        })
    };

    getUserData = () => {
        return new Promise((resolve, reject) => {
            request.get('/api/user')
                .then(resp => {
                    this.setState({
                        userD: resp.body.user,
                        userLoaded: true
                    });
                    //console.log('us', resp.body.user);
                    resolve(resp.body);
                });

        });
    };

    getcData = () => {
        return new Promise((resolve, reject) => {
            request.get('/api/user')
                .then(resp => {
                    this.setState({
                        cData: resp.body.user.cdata,
                        cDataLoaded: true
                    });
                    resolve(resp.body);
                });
        });
    };

    getCompanyData = () => {
        return new Promise((resolve, reject) => {
            request.get('/api/company')
                .then(resp => {
                    this.setState({
                        companyD: resp.body.company,
                        compLoaded: true,
                        address: resp.body.company.address,
                        city: resp.body.company.city,
                        postal: resp.body.company.postal,
                        country: resp.body.company.country,
                        state: resp.body.company.state,
                    });
                    resolve(resp.body);
                });

        });
    };

    formatPriceInput(priceStr) {
        const initialPrice = priceStr.split(" ");
        const price = initialPrice[1];
        return price;
    }

    formatDateInput(dateStr) {
        const mon = parseInt(dateStr.substring(0,2));
        const day = parseInt(dateStr.substring(3,5));
        const year = parseInt(dateStr.substring(6,10));
        const myDate = new Date(year, mon-1, day);
        return myDate;
    };

    formatDate(date) {
        if(date === null) {
            return null;
        } else {
            const ISOdate = date.toISOString();
            let unformatted = ISOdate.split('T');
            let justD = unformatted[0];
            let splitted = justD.split('-');
            let swapped = [splitted[1], splitted[2], splitted[0]];
            let myDateStr = swapped.join('\/');

            return myDateStr;
        }
    }

    handleVerifyAddress = async(address, city, state, postal, country) => {
        //evt.preventDefault();
        let geoloc = await request.post(`/api/company/address/coordinates`)
            .send ({"address": {"address": address, "country": country, "city": city, "state": state, "postal": postal}
            })
            .then(resp => {
                //console.log('response',resp.body.geospatial);
                return resp.body;
            })
            .catch(err => {
                console.log(err);
            });

        //console.log('geoloc', geoloc);
        if (geoloc !== undefined) {
            this.setState({
                geo: geoloc.geospatial,
                lat: geoloc.latitude,
                long: geoloc.longitude,
                address_status: "valid",
            })
        }

    };

    render() {

        const errors = this.validateAdr(this.state.address, this.state.city, this.state.state, this.state.state, this.state.country);
        //console.log('errors', errors);

        const isDisabled = Object.keys(errors).some(x => errors[x]);
        //console.log('isDisabled', isDisabled);

        //console.log('touched', this.state.touched);

        const shouldShowError = (fieldName) => {
            const hasErr = errors[fieldName];
            const shouldShow = this.state.touched[fieldName];
            return hasErr ? shouldShow : false;
        };


        //console.log('street address state', this.state.address);
        //console.log('city state', this.state.city);
        //console.log('postal state', this.state.postal);
        //console.log('country state', this.state.country);
        //console.log('state state', this.state.state);

        const countryOpts = [
            {id: '', display: 'Select Country'},
            {id: 'US', display: 'USA'},
            {id: 'CA', display: 'Canada'},
        ];

        const caStateOpts = [
            {id: '', display: 'Select State'},
            { id: 'AL', display: 'Alberta'},
            { id: 'BC', display: 'British Columbia'},
            { id: 'MA', display: 'Manitoba'},
            { id: 'NB', display: 'New Brunswik'},
            { id: 'NL', display: 'Newfoundlend and Labrador'},
            { id: 'NS', display: 'Nova Scotia'},
            { id: 'ON', display: 'Ontario'},
            { id: 'PEI', display: 'Price Edward Island'},
            { id: 'QU', display: 'Quebeck'},
            { id: 'SA', display: 'Saskatchewan'},
        ];

        const usStateOpts = [
            {id: '', display: 'Select State'},
            { id: 'AL', display: 'Alabama'},
            { id: 'AK', display: 'Alaska'},
            { id: 'AZ', display: 'Arizona'},
            { id: 'AR', display: 'Arkansas'},
            { id: 'CA', display: 'California'},
            { id: 'CO', display: 'Colorado'},
            { id: 'CT', display: 'Connecticut'},
            { id: 'DC', display: 'District of Columbia'},
            { id: 'DE', display: 'Delaware'},
            { id: 'FL', display: 'Florida'},
            { id: 'GA', display: 'Georgia'},
            { id: 'HI', display: 'Hawaii'},
            { id: 'ID', display: 'Idaho'},
            { id: 'IA', display: 'Iowa'},
            { id: 'IL', display: 'Illinois'},
            { id: 'IN', display: 'Indiana'},
            { id: 'KS', display: 'Kansas'},
            { id: 'KY', display: 'Kentucky'},
            { id: 'LA', display: 'Louisiana'},
            { id: 'ME', display: 'Maine'},
            { id: 'MD', display: 'Maryland'},
            { id: 'MA', display: 'Massachusetts'},
            { id: 'MI', display: 'Michigan'},
            { id: 'MN', display: 'Minnesota'},
            { id: 'MS', display: 'Mississippi'},
            { id: 'MO', display: 'Missouri'},
            { id: 'MT', display: 'Montana'},
            { id: 'NE', display: 'Nebraska'},
            { id: 'NH', display: 'New Hampshire'},
            { id: 'NJ', display: 'New Jersey'},
            { id: 'NM', display: 'New Mexico'},
            { id: 'NV', display: 'Nevada'},
            { id: 'NY', display: 'New York'},
            { id: 'NC', display: 'North Carolina'},
            { id: 'ND', display: 'North Dakota'},
            { id: 'OH', display: 'Ohio'},
            { id: 'OK', display: 'Oklahoma'},
            { id: 'OR', display: 'Oregon'},
            { id: 'PA', display: 'Pennsylvania'},
            { id: 'RI', display: 'Rhode Island'},
            { id: 'SC', display: 'South Carolina'},
            { id: 'SD', display: 'South Dakota'},
            { id: 'TN', display: 'Tennessee'},
            { id: 'TX', display: 'Texas'},
            { id: 'UT', display: 'Utah'},
            { id: 'VT', display: 'Vermont'},
            { id: 'VA', display: 'Virginia'},
            { id: 'WA', display: 'Washington'},
            { id: 'WV', display: 'West Virginia'},
            { id: 'WI', display: 'Wisconsin'},
            { id: 'WY', display: 'Wyoming'}
        ];

        const refferalOpts = [
            {id: "customer", display: "Customer"},
            {id: "distributor", display: "Distributer"},
            {id: "email", display: "Email"},
            {id: "facebook", display: "Facebook"},
            {id: "instagram", display: "Instagram"},
            {id: "lighting_showroom", display: "Lighting Showroom"},
            {id: "print_ad", display: "Print Ad"},
            {id: "sales_rep", display: "Sales Rep"},
            {id: "tradeshow", display: "Tradeshow"},
            {id: "tv", display: "TV"},
            {id: "word_of_mouth", display: "Word of Mouth"},
        ];

        const businessTypeOpts = [
            {id: "", display: "Business Type*"},
            {id: "architect", display: "Architect"},
            {id: "builder", display: "Builder"},
            {id: "designer", display: "Designer"},
            {id: "developer", display: "Developer"},
            {id: "property_manager", display: "Property Manager"},
            {id: "remodeler", display: "Remodeler"},
        ];

        const specArch = [
            {id: "", display: "Speciality*"},
            {id: "commercial", display: "Commercial"},
            {id: "residential", display: "Residential"},
        ];

        const specBuilder = [
            {id: "", display: "Speciality*"},
            {id: "custom", display: "Custom"},
            {id: "production", display: "Production"},
            {id: "specification", display: "Specification"},
            {id: "other", display: "Other"},
        ];

        const specDesigner = [
            {id: "", display: "Speciality*"},
            {id: "interior_designer", display: "Interior Designer"},
            {id: "lighting_designer", display: "Lighting Designer"},
            {id: "wellness_designer", display: "Wellness Designer"},
        ];

        const specDeveloper = [
            {id: "", display: "Speciality*"},
            {id: "commercial_property", display: "Commercial Property"},
            {id: "condominium", display: "Condominium/Apartment"},
            {id: "townhome_community", display: "Townhome Community"},
            {id: "other", display: "Other"},
        ];

        const specPropMan = [
            {id: "", display: "Speciality*"},
            {id: "commercial_property", display: "Commercial Property"},
            {id: "condominium", display: "Condominium/Apartment"},
            {id: "townhome_community", display: "Townhome Community"},
            {id: "other", display: "Other"},
        ];

        const specRemodeler = [
            {id: "", display: "Speciality*"},
            {id: "remodeler", display: "Remodeler"},
        ];

        const businessCoverageOpts = [
            {id: "", display: "Business Coverage"},
            {id: "local", display: "Local"},
            {id: "national", display: "National"},
            {id: "regional", display: "Regional"},

        ];

        const homeTypeOpts = [
            {id: "active_adult", display: "Active Adult"},
            {id: "entry_level", display: "Entry Level"},
            {id: "luxury", display: "Luxury"},
            {id: "move_up", display: "Move Up"},
            {id: "second_home_vacation", display: "Second Home/Vacation"},
        ];

        const projectSizeOpts = [
            {id: "", display: "Project Size"},
            {id: "1_100_homes", display: "1-100 Homes"},
            {id: "100_300_homes", display: "100-300 Homes"},
            {id: "300_plus_homes", display: "300+ Homes"},
        ];



        const ProfileSchema = Yup.object().shape({
            email: Yup.string().email('This value should be a valid email.').required('This value is required.'),
            first_name: Yup.string().required('This value is required.'),
            last_name: Yup.string().required('This value is required.'),
            name: Yup.string().required('This value is required.'),
            dba: Yup.string().required('This value is required.'),
            primary_jobtitle: Yup.string().required('This value is required.'),
            phone: Yup.string().required('This value is required.'),
            //country: Yup.string().required('This value is required.'),
            //address: Yup.string().required('This value is required.'),
            //city: Yup.string().required('This value is required.'),
            //state: Yup.string().required('This value is required.'),
            //postal: Yup.string().required('This value is required.').matches(/^[a-zA-Z0-9]*$/, 'This value should be alphanumeric characters only'),
            domain: Yup.string().required('This value is required.').url('This value should be a valid url.'),
            business_type: Yup.string().required('This value is required.'),
            speciality: Yup.string().required('This value is required.'),
            project_information_numberOfProjects: Yup.string().required('This value is required.'),
            project_information_numberOfHomes: Yup.string().required('This value is required.'),
            project_information_averageHomePrice: Yup.string().required('This value is required.'),
            project_information_primaryHomeTypes: Yup.string().required('This value is required.'),
            contractor_primaryEmail: Yup.string().email('This value should be a valid email.'),
            distributor_primaryEmail: Yup.string().email('This value should be a valid email.'),

        });

            let hearAboutNoon = "";
            if (this.state.cData.additional_information_hearAboutNoon != "" && this.state.cData.additional_information_hearAboutNoon != null) {
                hearAboutNoon = this.state.cData.additional_information_hearAboutNoon.split(',');
            }

            let homeTypes = "";
            if (this.state.cData.project_information_primaryHomeTypes != "" && this.state.cData.project_information_primaryHomeTypes != null) {
                homeTypes = this.state.cData.project_information_primaryHomeTypes.split(',');
            }

            let existingProj = false;
            if (this.state.cData.project_information_existingProjectToIncludeNoon === '1') {
                existingProj = true;
            }

            let contactN = false;
            if (this.state.cData.project_information_contactAboutExistingProject === '1') {
                contactN = true;
            }


            let projCompliteD = null;
            if (this.state.cData.project_information_projectCompletionDate != null && this.state.cData.project_information_projectCompletionDate != ""
                && this.state.cData.project_information_projectCompletionDate != "null"  && this.state.cData.project_information_projectCompletionDate != "undefined") {
                projCompliteD = this.formatDateInput(this.state.cData.project_information_projectCompletionDate);
            }



        //console.log('update', this.state.updateFlag);
        //console.log('edit', this.state.editingProfile);
        //console.log('error', this.state.isError);
        //console.log('compD', this.state.companyD);
        //console.log('cData', this.state.cData);

        return (
            <div>
                {this.state.userLoaded === true && this.state.compLoaded === true && this.state.cDataLoaded === true ?
                    <div className='profile-data'>
                        <div className='short-desc'>
                            <h5>{this.state.companyD.name}</h5>
                            <p>{this.state.companyD.address}, {this.state.companyD.city}, {this.state.companyD.state}</p>
                            <a className='user--domain--link'
                               href={this.state.companyD.domain}>{this.state.companyD.domain}</a>
                            <br/>
                            <button className='edit-p-button' onClick={this.editProfile}>Edit Profile</button>
                        </div>
                        <div className='profile-details'>
                            <h3>Primary Contact Information</h3>
                            {this.state.editingProfile === true ?
                                <Formik
                                    initialValues={{
                                        email: this.state.userD.email,
                                        first_name: this.state.cData.first_name,
                                        last_name: this.state.cData.last_name,
                                        name: this.state.companyD.name,
                                        dba: this.state.companyD.dba,
                                        primary_jobtitle: this.state.companyD.primary_jobtitle,
                                        phone: this.state.companyD.phone,
                                        address: this.state.companyD.address,
                                        country: this.state.companyD.country,
                                        city: this.state.companyD.city,
                                        state: this.state.companyD.state,
                                        postal: this.state.companyD.postal,
                                        domain: this.state.companyD.domain,


                                        business_type: this.state.companyD.business_type,
                                        speciality: this.state.companyD.speciality,
                                        business_coverage: this.state.companyD.business_coverage,

                                        additional_information_hearAboutNoon: hearAboutNoon,
                                        project_information_numberOfProjects: this.state.cData.project_information_numberOfProjects,
                                        project_information_numberOfHomes: this.state.cData.project_information_numberOfHomes,
                                        project_information_averageHomePrice: this.formatPriceInput(this.state.cData.project_information_averageHomePrice),
                                        project_information_primaryHomeTypes: homeTypes,
                                        project_information_projectSize: this.state.cData.project_information_projectSize,
                                        project_information_projectCompletionDate: projCompliteD,
                                        project_information_existingProjectToIncludeNoon: existingProj,
                                        project_information_contactAboutExistingProject: contactN,
                                        contractor_companyName: this.state.cData.contractor_companyName,
                                        contractor_primaryContact: this.state.cData.contractor_primaryContact,
                                        contractor_primaryEmail: this.state.cData.contractor_primaryEmail,
                                        distributor_companyName: this.state.cData.distributor_companyName,
                                        distributor_primaryContact: this.state.cData.distributor_primaryContact,
                                        distributor_primaryEmail: this.state.cData.distributor_primaryEmail,


                                    }}
                                    enableReinitialize={true}
                                    validationSchema={ProfileSchema}
                                    onSubmit={ async (values, actions) => {

                                        let hearedAbout = "";
                                        if (values.additional_information_hearAboutNoon != "" && values.additional_information_hearAboutNoon != []) {
                                            hearedAbout = values.additional_information_hearAboutNoon.join(",")
                                        }

                                        let homeTypes = "";
                                        if (values.project_information_primaryHomeTypes != "" && values.project_information_primaryHomeTypes != []) {
                                            homeTypes = values.project_information_primaryHomeTypes.join(",")
                                        }

                                        let projectWithNoon = "";
                                        if (values.project_information_existingProjectToIncludeNoon === false) {
                                            projectWithNoon = "0";
                                        }
                                        if (values.project_information_existingProjectToIncludeNoon === true) {
                                            projectWithNoon = "1";
                                        }


                                        let contactNoon = "";
                                        if (values.project_information_contactAboutExistingProject === false) {
                                            contactNoon = "0";
                                        }

                                        if (values.project_information_contactAboutExistingProject === true) {
                                            contactNoon = "1";
                                        }

                                        let nofHomes = values.project_information_numberOfHomes.toString();

                                        let nofProjects = values.project_information_numberOfProjects.toString();

                                        let formattedD = this.formatDate(values.project_information_projectCompletionDate);

                                        let avgPrice = `$ ${values.project_information_averageHomePrice}`;

                                        let data =  await this.handleVerifyAddress(this.state.address, this.state.city, this.state.state, this.state.postal, this.state.country,);

                                        return Promise.all([
                                            request.post('/api/user')
                                                .send({
                                                    email: values.email,
                                                    first_name: values.first_name,
                                                    last_name: values.last_name,
                                                    additional_information_hearAboutNoon: hearedAbout,
                                                    project_information_numberOfProjects: nofProjects,
                                                    project_information_numberOfHomes: nofHomes,
                                                    project_information_primaryHomeTypes: homeTypes,
                                                    project_information_existingProjectToIncludeNoon: projectWithNoon,
                                                    project_information_contactAboutExistingProject: contactNoon,
                                                    project_information_projectSize: values.project_information_projectSize,
                                                    project_information_averageHomePrice: avgPrice,
                                                    project_information_projectCompletionDate: formattedD,
                                                    contractor_companyName: values.contractor_companyName,
                                                    contractor_primaryContact: values.contractor_primaryContact,
                                                    contractor_primaryEmail: values.contractor_primaryEmail,
                                                    distributor_companyName: values.distributor_companyName,
                                                    distributor_primaryContact: values.distributor_primaryContact,
                                                    distributor_primaryEmail: values.distributor_primaryEmail,
                                                }),
                                            request.post('/api/company')
                                                .send({
                                                    name: values.name,
                                                    dba: values.dba,
                                                    primary_jobtitle: values.primary_jobtitle,
                                                    phone: values.phone,
                                                    country: this.state.country,
                                                    address: this.state.address,
                                                    city: this.state.city,
                                                    state: this.state.state,
                                                    postal: this.state.postal,
                                                    domain: values.domain,
                                                    business_type: values.business_type,
                                                    speciality: values.speciality,
                                                    business_coverage: values.business_coverage,
                                                    address_status: this.state.address_status,
                                                    latitude: this.state.lat,
                                                    longitude: this.state.long,
                                                    geospatial: this.state.geo,

                                                    coverage_range: null,
                                                    years_in_business: null,
                                                    number_of_employees: null,

                                                    experience_with_noon: false,
                                                    dealer_finder: false,
                                                    provide_staff_training: false,

                                                })
                                        ])
                                            .then(data => {
                                                //console.log('finished user call');
                                                //console.log(data);
                                                this.setState({
                                                    updateFlag: true,
                                                    geo: null,
                                                    lat: null,
                                                    long: null,
                                                    address_status:'',
                                                });
                                            })
                                            .catch(err => {
                                                console.error(err);
                                                this.setState({isError: true});
                                            });
                                    }}>
                                    {({
                                          values,
                                          errors,
                                          touched,
                                          handleChange,
                                          handleBlur,
                                          handleSubmit,
                                          isSubmitting,
                                          setFieldValue,
                                          handleReset,
                                          dirty,
                                          isValid,
                                          isValidating,

                                      }) => (
                                        <Form className='my-f-form' onSubmit={e => {
                                            handleSubmit(e);
                                            if(isDisabled === true) {
                                                this.handleSubmitErr(e)
                                            }
                                        }}>
                                            <h3 className='profile-data-section'>Primary Contact Information</h3>
                                            <label className='form-f-label'>Email*</label>
                                            <Field
                                                name='email'
                                                className={errors.email && touched.email ? 'form-f-field with-error' : 'form-f-field'}
                                                component='input'
                                                type='text'
                                                placeholder='Email*'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.email}/>
                                            {errors.email && touched.email ?
                                                (<div className='f-field-errors'>{errors.email} </div>) : null
                                            }

                                            <div className='flex--fields--holder'>
                                                <div className='flex-field-container'>
                                                    <label className='form-f-label'>First Name*</label>
                                                    <div className='flex-with-error-holder'>
                                                        <Field
                                                            name='first_name'
                                                            component='input'
                                                            className={errors.first_name && touched.first_name ? 'form-f-field flex-with-error' : 'form-f-field'}
                                                            type='text'
                                                            placeholder='First Name*'
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            value={values.first_name}
                                                        />
                                                        {errors.first_name && touched.first_name ? (
                                                            <div
                                                                className='f-field-errors'>{errors.first_name}</div>) : null
                                                        }
                                                    </div>
                                                </div>

                                                <div className='flex-field-container last'>
                                                    <label className='form-f-label'>Last Name*</label>
                                                    <div className='flex-with-error-holder'>
                                                        <Field
                                                            name='last_name'
                                                            component='input'
                                                            className={errors.last_name && touched.last_name ? 'form-f-field flex-with-error' : 'form-f-field'}
                                                            type='text'
                                                            placeholder='Last Name*'
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            value={values.last_name}
                                                        />
                                                        {errors.last_name && touched.last_name ?
                                                            (<div
                                                                className='f-field-errors'>{errors.last_name}</div>) : null
                                                        }
                                                    </div>
                                                </div>
                                            </div>

                                            <h3 className='profile-data-section'>Business Information</h3>

                                            <label className='form-f-label'>Company Name*</label>
                                            <Field
                                                name='name'
                                                component='input'
                                                className={errors.name && touched.name ? 'form-f-field with-error' : 'form-f-field'}
                                                type='text'
                                                placeholder='Company Name*'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.name}
                                            />
                                            {errors.name && touched.name ?
                                                (<div className='f-field-errors'>{errors.name}</div>) : null
                                            }

                                            <label className='form-f-label'>Doing Business As (DBA)*</label>
                                            <Field
                                                name='dba'
                                                component='input'
                                                className={errors.dba && touched.dba ? 'form-f-field with-error' : 'form-f-field'}
                                                type='text'
                                                placeholder='Doing Business As*'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.dba}
                                            />
                                            {errors.dba && touched.dba ?
                                                (<div className='f-field-errors'>{errors.dba}</div>) : null
                                            }

                                            <label className='form-f-label'>Job Title*</label>
                                            <Field
                                                name='primary_jobtitle'
                                                component='input'
                                                className={errors.primary_jobtitle && touched.primary_jobtitle ? 'form-f-field with-error' : 'form-f-field'}
                                                type='text'
                                                placeholder='Job Title*'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.primary_jobtitle}
                                            />
                                            {errors.primary_jobtitle && touched.primary_jobtitle ?
                                                (<div className='f-field-errors'>{errors.primary_jobtitle}</div>) : null
                                            }

                                            <label className='form-f-label'>Primary Phone*</label>
                                            <Field
                                                name='phone'
                                                component='input'
                                                className={errors.phone && touched.phone ? 'form-f-field with-error' : 'form-f-field'}
                                                type='text'
                                                placeholder='(___)___-____'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.phone}
                                            />
                                            {errors.phone && touched.phone ?
                                                (<div className='f-field-errors'>{errors.phone}</div>) : null
                                            }

                                            <label className='form-f-label'>Country*</label>
                                            <select
                                                id='addressAutocomplete.country'
                                                name='country'
                                                className='single-choice-selector'
                                                value={this.state.country}
                                                onChange={e => this.handleCountryChange(e)}
                                                onBlur={this.handleAdrBlur('country')}
                                            >
                                                {countryOpts.map(option => (
                                                    <option key={`country-${option.id}`} value={option.id}>
                                                        {option.display}
                                                    </option>
                                                ))}
                                            </select>
                                            {shouldShowError('country') ?
                                                (<div className='f-field-errors'>This value is required.</div>) : null
                                            }

                                            <label className='form-f-label'>Address*</label>
                                            <input
                                                name='address'
                                                className={shouldShowError('address') ? 'form-f-field with-error' : 'form-f-field'}
                                                type='text'
                                                id='addressAutocomplete.street'
                                                placeholder='Address*'
                                                value={this.state.address}
                                                onChange={e => this.handleAdrChange(e)}
                                                onBlur={this.handleAdrBlur('address')}
                                            />
                                            {shouldShowError('address') ?
                                                (<div className='f-field-errors'>This value is required.</div>) : null
                                            }

                                            <div className='flex--fields--holder'>
                                                <div className='flex-field-container'>
                                                    <label className='form-f-label'>City*</label>
                                                    <input
                                                        name='city'
                                                        className={shouldShowError('city') ? 'form-f-field with-error' : 'form-f-field'}
                                                        type='text'
                                                        id='addressAutocomplete.city'
                                                        placeholder='City*'
                                                        value={this.state.city}
                                                        onChange={e => this.handleCityChange(e)}
                                                        onBlur={this.handleAdrBlur('city')}
                                                    />
                                                    {shouldShowError('city') ?
                                                        (<div className='f-field-errors'>This value is required.</div>) : null
                                                    }
                                                </div>

                                                {this.state.country === 'CA' ?
                                                    <div className='flex-field-container'>
                                                        <label className='flex-form-label'>State*</label>
                                                        <select
                                                            name='state'
                                                            id='addressAutocomplete.state'
                                                            className='state-selector'
                                                            placeholder='State'
                                                            value={this.state.state}
                                                            onChange={e => this.handleStateChange(e)}
                                                            onBlur={this.handleAdrBlur('state')}
                                                        >
                                                            {caStateOpts.map(option => (
                                                                <option key={`state-${option.id}`}
                                                                        value={option.id}>
                                                                    {option.display}
                                                                </option>
                                                            ))}
                                                        </select>
                                                        {shouldShowError('state') ?
                                                            (<div className='f-field-errors'>This value is required.</div>) : null
                                                        }
                                                    </div>:
                                                    <div className='flex-field-container'>
                                                        <label className='flex-form-label'>State*</label>
                                                        <select
                                                            name='state'
                                                            id='addressAutocomplete.state'
                                                            className='state-selector'
                                                            placeholder='State'
                                                            value={this.state.state}
                                                            onChange={e => this.handleStateChange(e)}
                                                            onBlur={this.handleAdrBlur('state')}
                                                        >
                                                            {usStateOpts.map(option => (
                                                                <option key={`state-${option.id}`}
                                                                        value={option.id}>
                                                                    {option.display}
                                                                </option>
                                                            ))}
                                                        </select>
                                                        {shouldShowError('state') ?
                                                            (<div className='f-field-errors'>This value is required.</div>) : null
                                                        }
                                                    </div>
                                                }

                                                <div className='flex-field-container last'>
                                                    <label className='form-f-label'>Postal Code*</label>
                                                    <input
                                                        name='postal'
                                                        id='addressAutocomplete.postal'
                                                        className={shouldShowError('postal') ? 'form-f-field with-error' : 'form-f-field'}
                                                        type='text'
                                                        placeholder='Postal Code*'
                                                        value={this.state.postal}
                                                        onChange={e => this.handlePostalChange(e)}
                                                        onBlur={this.handleAdrBlur('postal')}
                                                    />
                                                    {shouldShowError('postal') ?
                                                        (<div className='f-field-errors'>This value is required.</div>) : null
                                                    }
                                                </div>
                                            </div>

                                            <label className='form-f-label'>Website*</label>
                                            <Field
                                                name='domain'
                                                component='input'
                                                className={errors.domain && touched.domain ? 'form-f-field with-error' : 'form-f-field'}
                                                type='text'
                                                placeholder='Website*'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.domain}
                                            />
                                            {errors.domain && touched.domain ?
                                                (<div className='f-field-errors'>{errors.domain}</div>) : null
                                            }

                                            <label className='form-f-label'>Business Type*</label>
                                            <Field name='business_type' component='select'
                                                   className='single-choice-selector'>
                                                {businessTypeOpts.map(option => (
                                                    <option key={`business_type-${option.id}`} value={option.id}>
                                                        {option.display}
                                                    </option>
                                                ))}
                                            </Field>
                                            {errors.business_type && touched.business_type ?
                                                (<div className='f-field-errors'>{errors.business_type}</div>) : null
                                            }

                                            {values.business_type === "" ?
                                                <div>
                                                    <label className='form-f-label'>Speciality*</label>
                                                    <Field name='speciality' component='select'
                                                           className='single-choice-selector disabled' disabled={true}>
                                                        {specArch.map(option => (
                                                            <option key={`speciality-${option.id}`} value={option.id}>
                                                                {option.display}
                                                            </option>
                                                        ))}
                                                    </Field>
                                                    {errors.speciality && touched.speciality ?
                                                        (<div
                                                            className='f-field-errors'>{errors.speciality}</div>) : null
                                                    }
                                                </div> :
                                                null
                                            }

                                            {values.business_type === 'architect' ?
                                                <div>
                                                    <label className='form-f-label'>Speciality*</label>
                                                    <Field name='speciality' component='select'
                                                           className='single-choice-selector'>
                                                        {specArch.map(option => (
                                                            <option key={`speciality-${option.id}`} value={option.id}>
                                                                {option.display}
                                                            </option>
                                                        ))}
                                                    </Field>
                                                    {errors.speciality && touched.speciality ?
                                                        (<div
                                                            className='f-field-errors'>{errors.speciality}</div>) : null
                                                    }
                                                </div> :
                                                null
                                            }

                                            {values.business_type === 'builder' ?
                                                <div>
                                                    <label className='form-f-label'>Speciality*</label>
                                                    <Field name='speciality' component='select'
                                                           className='single-choice-selector'>
                                                        {specBuilder.map(option => (
                                                            <option key={`speciality-${option.id}`} value={option.id}>
                                                                {option.display}
                                                            </option>
                                                        ))}
                                                    </Field>
                                                    {errors.speciality && touched.speciality ?
                                                        (<div
                                                            className='f-field-errors'>{errors.speciality}</div>) : null
                                                    }
                                                </div> :
                                                null
                                            }

                                            {values.business_type === 'designer' ?
                                                <div>
                                                    <label className='form-f-label'>Speciality*</label>
                                                    <Field name='speciality' component='select'
                                                           className='single-choice-selector'>
                                                        {specDesigner.map(option => (
                                                            <option key={`speciality-${option.id}`} value={option.id}>
                                                                {option.display}
                                                            </option>
                                                        ))}
                                                    </Field>
                                                    {errors.speciality && touched.speciality ?
                                                        (<div
                                                            className='f-field-errors'>{errors.speciality}</div>) : null
                                                    }
                                                </div> :
                                                null
                                            }

                                            {values.business_type === 'developer' ?
                                                <div>
                                                    <label className='form-f-label'>Speciality*</label>
                                                    <Field name='speciality' component='select'
                                                           className='single-choice-selector'>
                                                        {specDeveloper.map(option => (
                                                            <option key={`speciality-${option.id}`} value={option.id}>
                                                                {option.display}
                                                            </option>
                                                        ))}
                                                    </Field>
                                                    {errors.speciality && touched.speciality ?
                                                        (<div
                                                            className='f-field-errors'>{errors.speciality}</div>) : null
                                                    }
                                                </div> :
                                                null
                                            }

                                            {values.business_type === 'property_manager' ?
                                                <div>
                                                    <label className='form-f-label'>Speciality*</label>
                                                    <Field name='speciality' component='select'
                                                           className='single-choice-selector'>
                                                        {specPropMan.map(option => (
                                                            <option key={`speciality-${option.id}`} value={option.id}>
                                                                {option.display}
                                                            </option>
                                                        ))}
                                                    </Field>
                                                    {errors.speciality && touched.speciality ?
                                                        (<div
                                                            className='f-field-errors'>{errors.speciality}</div>) : null
                                                    }
                                                </div> :
                                                null
                                            }

                                            {values.business_type === 'remodeler' ?
                                                <div>
                                                    <label className='form-f-label'>Speciality*</label>
                                                    <Field name='speciality' component='select'
                                                           className='single-choice-selector'>
                                                        {specRemodeler.map(option => (
                                                            <option key={`speciality-${option.id}`} value={option.id}>
                                                                {option.display}
                                                            </option>
                                                        ))}
                                                    </Field>
                                                    {errors.speciality && touched.speciality ?
                                                        (<div
                                                            className='f-field-errors'>{errors.speciality}</div>) : null
                                                    }
                                                </div> :
                                                null
                                            }

                                            <label className='form-f-label'>Business Coverage</label>
                                            <Field name='business_coverage' component='select'
                                                   className='single-choice-selector'>
                                                {businessCoverageOpts.map(option => (
                                                    <option key={`business_coverage-${option.id}`} value={option.id}>
                                                        {option.display}
                                                    </option>
                                                ))}
                                            </Field>

                                            <h3 className='profile-data-section'>Project Information</h3>

                                            <label className='form-f-label'>Number of Projects/Year*</label>
                                            <Field
                                                name='project_information_numberOfProjects'
                                                component='input'
                                                className={errors.project_information_numberOfProjects && touched.project_information_numberOfProjects ? 'form-f-field with-error' : 'form-f-field'}
                                                type='number'
                                                placeholder='Number of Projects/Year*'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.project_information_numberOfProjects}
                                            />
                                            {errors.project_information_numberOfProjects && touched.project_information_numberOfProjects ?
                                                (<div
                                                    className='f-field-errors'>{errors.project_information_numberOfProjects}</div>) : null
                                            }

                                            <label className='form-f-label'>Number of Homes/Projects*</label>
                                            <Field
                                                name='project_information_numberOfHomes'
                                                component='input'
                                                className={errors.project_information_numberOfHomes && touched.project_information_numberOfHomes ? 'form-f-field with-error' : 'form-f-field'}
                                                type='number'
                                                placeholder='Number of Homes/Projects*'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.project_information_numberOfHomes}
                                            />
                                            {errors.project_information_numberOfHomes && touched.project_information_numberOfHomes ?
                                                (<div
                                                    className='f-field-errors'>{errors.project_information_numberOfHomes}</div>) : null
                                            }

                                            <label className='form-f-label'>Average Home Price *</label>
                                            <FormattedNumInput
                                                className={errors.project_information_averageHomePrice && touched.project_information_averageHomePrice ? 'form-f-field with-error' : 'form-f-field'}
                                                name='project_information_averageHomePrice'
                                                placeholder='$ 0.00'
                                                value={values.project_information_averageHomePrice}
                                                onChange={handleChange('project_information_averageHomePrice')}
                                            />
                                            {errors.project_information_averageHomePrice && touched.project_information_averageHomePrice ?
                                                (<div
                                                    className='f-field-errors'>{errors.project_information_averageHomePrice}</div>) : null
                                            }

                                            <label className='form-f-label'>Primary Home Types *</label>
                                            <label className='second-f-label'>Select Options:</label>
                                            <div className='box--outline-comp'>
                                                <div className='checkbox-group-content'>
                                                    <FieldArray
                                                        name='project_information_primaryHomeTypes'
                                                        render={arrayHelpers => (
                                                            <div>
                                                                {homeTypeOpts.map(option => (
                                                                    <div key={option.id}>
                                                                        <input
                                                                            name='project_information_primaryHomeTypes'
                                                                            type='checkbox'
                                                                            value={option.id}
                                                                            checked={values.project_information_primaryHomeTypes.includes(option.id)}
                                                                            onChange={event => {
                                                                                if (event.target.checked) {
                                                                                    arrayHelpers.push(option.id);
                                                                                }
                                                                                else {
                                                                                    const idx = values.project_information_primaryHomeTypes.indexOf(option.id);
                                                                                    arrayHelpers.remove(idx);
                                                                                }
                                                                            }}
                                                                        /> {option.display}
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )}
                                                    />
                                                </div>
                                            </div>
                                            {errors.project_information_primaryHomeTypes && touched.project_information_primaryHomeTypes ?
                                                (<div
                                                    className='f-field-errors'>{errors.project_information_primaryHomeTypes}</div>) : null
                                            }

                                            <div className='toggle-switch-gr'>
                                                <input
                                                    type='checkbox'
                                                    className='toggle--input--btn'
                                                    name='project_information_existingProjectToIncludeNoon'
                                                    checked={values.project_information_existingProjectToIncludeNoon}
                                                    onChange={handleChange}
                                                />
                                                <p className='toggle-in-label'>Do you have an existing project you would
                                                    like to include NOON on?</p>
                                            </div>

                                            {values.project_information_existingProjectToIncludeNoon === true ?
                                                <div>

                                                    <label className='form-f-label'>Project Size</label>
                                                    <Field name='project_information_projectSize' component='select'
                                                           className='single-choice-selector'>
                                                        {projectSizeOpts.map(option => (
                                                            <option key={`project_information_projectSize-${option.id}`}
                                                                    value={option.id}>
                                                                {option.display}
                                                            </option>
                                                        ))}
                                                    </Field>

                                                    <label className='form-f-label'>Project Completion Date</label>
                                                    <DatePickerComponent
                                                        classStyle='form-f-field'
                                                        id='project_information_projectCompletionDate'
                                                        value={values.project_information_projectCompletionDate}
                                                        onChange={setFieldValue}
                                                        greyed={false}
                                                        startDateValue={projCompliteD}
                                                        placeholderT='Project Completion Date'
                                                        canClear={true}
                                                    />
                                                </div> :
                                                <div>
                                                    <label className='form-f-label '>Project Size</label>
                                                    <Field name='project_information_projectSize' component='select'
                                                           className='single-choice-selector disabled' disabled={true}>
                                                        {projectSizeOpts.map(option => (
                                                            <option key={`project_information_projectSize-${option.id}`}
                                                                    value={option.id}>
                                                                {option.display}
                                                            </option>
                                                        ))}
                                                    </Field>

                                                    <label className='form-f-label'>Project Completion Date</label>
                                                    <DatePickerComponent
                                                        classStyle='form-f-field disabled'
                                                        id='project_information_projectCompletionDate'
                                                        value={values.project_information_projectCompletionDate}
                                                        onChange={setFieldValue}
                                                        greyed={true}
                                                        startDateValue={projCompliteD}
                                                        placeholderT='Project Completion Date'
                                                        canClear={false}
                                                    />
                                                </div>
                                            }

                                            <br/>

                                            <div className='toggle-switch-gr'>
                                                <input
                                                    type='checkbox'
                                                    className='toggle--input--btn'
                                                    name='project_information_contactAboutExistingProject'
                                                    checked={values.project_information_contactAboutExistingProject}
                                                    onChange={handleChange}
                                                />
                                                <p className='toggle-in-label'>Would you like NOON to contact you to
                                                    help specify your project?</p>
                                            </div>
                                            <h3 className='profile-data-section'>Additional Information</h3>

                                            <label className='form-f-label'>How you heard about NOON?</label>
                                            <label className='second-f-label'>Select Options:</label>
                                            <div className='box--outline-comp'>
                                                <div className='checkbox-group-content'>
                                                    <FieldArray
                                                        name='additional_information_hearAboutNoon'
                                                        render={arrayHelpers => (
                                                            <div>
                                                                {refferalOpts.map(option => (
                                                                    <div key={option.id}>
                                                                        <input
                                                                            name='additional_information_hearAboutNoon'
                                                                            type='checkbox'
                                                                            value={option.id}
                                                                            checked={values.additional_information_hearAboutNoon.includes(option.id)}
                                                                            onChange={event => {
                                                                                if (event.target.checked) {
                                                                                    arrayHelpers.push(option.id);
                                                                                }
                                                                                else {
                                                                                    const idx = values.additional_information_hearAboutNoon.indexOf(option.id);
                                                                                    arrayHelpers.remove(idx);
                                                                                }
                                                                            }}
                                                                        /> {option.display}
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )}
                                                    />
                                                </div>
                                            </div>

                                            <h3 className='profile-data-section'>Refer Your Contractor</h3>

                                            <label className='form-f-label'>Company Name</label>
                                            <Field
                                                name='contractor_companyName'
                                                component='input'
                                                className='form-f-field'
                                                type='text'
                                                placeholder='Company Name'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.contractor_companyName}
                                            />

                                            <label className='form-f-label'>Primary Contact</label>
                                            <Field
                                                name='contractor_primaryContact'
                                                component='input'
                                                className='form-f-field'
                                                type='text'
                                                placeholder='Primary Contact'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.contractor_primaryContact}
                                            />

                                            <label className='form-f-label'>Primary Email</label>
                                            <Field
                                                name='contractor_primaryEmail'
                                                component='input'
                                                className={errors.contractor_primaryEmail && touched.contractor_primaryEmail ? 'form-f-field with-error' : 'form-f-field'}
                                                type='text'
                                                placeholder='Primary Email'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.contractor_primaryEmail}
                                            />
                                            {errors.contractor_primaryEmail && touched.contractor_primaryEmail ?
                                                (<div
                                                    className='f-field-errors'>{errors.contractor_primaryEmail}</div>) : null
                                            }
                                            <br/>
                                            <br/>
                                            <p className='dop-f-disclaimer'>* We will send an email inviting them to
                                                sign up for NOON Pro.</p>

                                            <h3 className='profile-data-section'>Refer Your Distributor</h3>

                                            <label className='form-f-label'>Company Name</label>
                                            <Field
                                                name='distributor_companyName'
                                                component='input'
                                                className='form-f-field'
                                                type='text'
                                                placeholder='Company Name'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.distributor_companyName}
                                            />

                                            <label className='form-f-label'>Primary Contact</label>
                                            <Field
                                                name='distributor_primaryContact'
                                                component='input'
                                                className='form-f-field'
                                                type='text'
                                                placeholder='Primary Contact'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.distributor_primaryContact}
                                            />

                                            <label className='form-f-label'>Primary Email</label>
                                            <Field
                                                name='distributor_primaryEmail'
                                                component='input'
                                                className={errors.distributor_primaryEmail && touched.distributor_primaryEmail ? 'form-f-field with-error' : 'form-f-field'}
                                                type='text'
                                                placeholder='Primary Email'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.distributor_primaryEmail}
                                            />
                                            {errors.distributor_primaryEmail && touched.distributor_primaryEmail ?
                                                (<div
                                                    className='f-field-errors'>{errors.distributor_primaryEmail}</div>) : null
                                            }
                                            <br/>
                                            <br/>
                                            <p className='dop-f-disclaimer'>* We will send an email inviting them to
                                                sign up for NOON Pro.</p>

                                            {this.state.isError === true ?
                                                <p className='submission-error-text'>Ooops something went wrong! Please
                                                    try again later</p> :
                                                null
                                            }

                                            { isDisabled === true ?
                                                <button type='submit' className='form-f-button' onClick={e => this.handleSubmitErr(e)}> Save Profile</button> :
                                                <button type='submit' className='form-f-button'> Save Profile</button>
                                            }

                                            {dirty ?
                                                <a className='form-cancel-button'
                                                   onClick={handleReset}>
                                                    Reset Form
                                                </a> :
                                                <a className='form-cancel-button'
                                                   onClick={this.editProfile}>
                                                    Cancel
                                                </a>
                                            }
                                        </Form>
                                    )}


                                </Formik> :
                                <Formik
                                    initialValues={{
                                        email: this.state.userD.email,
                                        first_name: this.state.cData.first_name,
                                        last_name: this.state.cData.last_name,
                                        name: this.state.companyD.name,
                                        dba: this.state.companyD.dba,
                                        primary_jobtitle: this.state.companyD.primary_jobtitle,
                                        phone: this.state.companyD.phone,
                                        address: this.state.companyD.address,
                                        country: this.state.companyD.country,
                                        city: this.state.companyD.city,
                                        state: this.state.companyD.state,
                                        postal: this.state.companyD.postal,
                                        domain: this.state.companyD.domain,


                                        business_type: this.state.companyD.business_type,
                                        speciality: this.state.companyD.speciality,
                                        business_coverage: this.state.companyD.business_coverage,

                                        additional_information_hearAboutNoon: hearAboutNoon,
                                        project_information_numberOfProjects: this.state.cData.project_information_numberOfProjects,
                                        project_information_numberOfHomes: this.state.cData.project_information_numberOfHomes,
                                        project_information_averageHomePrice: this.state.cData.project_information_averageHomePrice,
                                        project_information_primaryHomeTypes: homeTypes,
                                        project_information_projectSize: this.state.cData.project_information_projectSize,
                                        project_information_projectCompletionDate: projCompliteD,
                                        project_information_existingProjectToIncludeNoon: existingProj,
                                        project_information_contactAboutExistingProject: contactN,
                                        contractor_companyName: this.state.cData.contractor_companyName,
                                        contractor_primaryContact: this.state.cData.contractor_primaryContact,
                                        contractor_primaryEmail: this.state.cData.contractor_primaryEmail,
                                        distributor_companyName: this.state.cData.distributor_companyName,
                                        distributor_primaryContact: this.state.cData.distributor_primaryContact,
                                        distributor_primaryEmail: this.state.cData.distributor_primaryEmail,


                                    }}
                                    enableReinitialize={true}
                                    validationSchema={ProfileSchema}
                                    onSubmit={(values, actions) => {

                                        let hearedAbout = "";
                                        if (values.additional_information_hearAboutNoon != "" && values.additional_information_hearAboutNoon != []) {
                                            hearedAbout = values.additional_information_hearAboutNoon.join(",")
                                        }

                                        let homeTypes = "";
                                        if (values.project_information_primaryHomeTypes != "" && values.project_information_primaryHomeTypes != []) {
                                            homeTypes = values.project_information_primaryHomeTypes.join(",")
                                        }

                                        let projectWithNoon = "";
                                        if (values.project_information_existingProjectToIncludeNoon === false) {
                                            projectWithNoon = "0";
                                        }
                                        if (values.project_information_existingProjectToIncludeNoon === true) {
                                            projectWithNoon = "1";
                                        }


                                        let contactNoon = "";
                                        if (values.project_information_contactAboutExistingProject === false) {
                                            contactNoon = "0";
                                        }

                                        if (values.project_information_contactAboutExistingProject === true) {
                                            contactNoon = "1";
                                        }

                                        let nofHomes = values.project_information_numberOfHomes.toString();

                                        let nofProjects = values.project_information_numberOfProjects.toString();

                                        let formattedD = this.formatDate(values.project_information_projectCompletionDate);

                                        let avgPrice = `$ ${values.project_information_averageHomePrice}`;


                                        return Promise.all([
                                            request.post('/api/user')
                                                .send({
                                                    email: values.email,
                                                }),
                                            request.post('/api/company')
                                                .send({
                                                    name: values.name,
                                                })
                                        ])
                                            .then(data => {
                                                console.log('finished user call');
                                                console.log(data);
                                                this.setState({
                                                    updateFlag: true
                                                });
                                            })
                                            .catch(err => {
                                                console.error(err);
                                                this.setState({isError: true});
                                            });
                                    }}>
                                    {({
                                          values,
                                          errors,
                                          touched,
                                          handleChange,
                                          handleBlur,
                                          handleSubmit,
                                          isSubmitting,
                                          setFieldValue,
                                          handleReset,
                                          dirty,

                                      }) => (
                                        <Form className='my-f-form' onSubmit={handleSubmit}>
                                            <label className='form-f-label'>Email*</label>
                                            <Field
                                                name='email'
                                                className={errors.email && touched.email ? 'form-f-field with-error' : 'form-f-field'}
                                                component='input'
                                                type='text'
                                                placeholder='Email*'
                                                disabled={true}
                                                value={values.email}
                                            />
                                            <div className='flex--fields--holder'>
                                                <div className='flex-field-container'>
                                                    <label className='form-f-label'>First Name*</label>
                                                    <div className='flex-with-error-holder'>
                                                        <Field
                                                            name='first_name'
                                                            component='input'
                                                            className={errors.first_name && touched.first_name ? 'form-f-field flex-with-error' : 'form-f-field'}
                                                            type='text'
                                                            placeholder='First Name*'
                                                            disabled={true}
                                                            value={values.first_name}
                                                        />
                                                    </div>
                                                </div>

                                                <div className='flex-field-container last'>
                                                    <label className='form-f-label'>Last Name*</label>
                                                    <div className='flex-with-error-holder'>
                                                        <Field
                                                            name='last_name'
                                                            component='input'
                                                            className={errors.last_name && touched.last_name ? 'form-f-field flex-with-error' : 'form-f-field'}
                                                            type='text'
                                                            placeholder='Last Name*'
                                                            disabled={true}
                                                            value={values.last_name}
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <h3 className='profile-data-section'>Business Information</h3>

                                            <label className='form-f-label'>Company Name*</label>
                                            <Field
                                                name='name'
                                                component='input'
                                                className={errors.name && touched.name ? 'form-f-field with-error' : 'form-f-field'}
                                                type='text'
                                                placeholder='Company Name*'
                                                disabled={true}
                                                value={values.name}
                                            />


                                            <label className='form-f-label'>Doing Business As (DBA)*</label>
                                            <Field
                                                name='dba'
                                                component='input'
                                                className={errors.dba && touched.dba ? 'form-f-field with-error' : 'form-f-field'}
                                                type='text'
                                                placeholder='Doing Business As*'
                                                disabled={true}
                                                value={values.dba}
                                            />


                                            <label className='form-f-label'>Job Title*</label>
                                            <Field
                                                name='primary_jobtitle'
                                                component='input'
                                                className={errors.primary_jobtitle && touched.primary_jobtitle ? 'form-f-field with-error' : 'form-f-field'}
                                                type='text'
                                                placeholder='Job Title*'
                                                disabled={true}
                                                value={values.primary_jobtitle}
                                            />


                                            <label className='form-f-label'>Primary Phone*</label>
                                            <Field
                                                name='phone'
                                                component='input'
                                                className={errors.phone && touched.phone ? 'form-f-field with-error' : 'form-f-field'}
                                                type='text'
                                                placeholder='(___)___-____'
                                                disabled={true}
                                                value={values.phone}
                                            />

                                            <label className='form-f-label'>Country*</label>
                                            <Field name='country' component='select' disabled={true}
                                                   className='single-choice-selector'>
                                                {countryOpts.map(option => (
                                                    <option key={`country-${option.id}`} value={option.id}>
                                                        {option.display}
                                                    </option>
                                                ))}
                                            </Field>
                                            {errors.country && touched.country ?
                                                (<div className='f-field-errors'>{errors.country}</div>) : null
                                            }

                                            <label className='form-f-label'>Address*</label>
                                            <Field
                                                name='address'
                                                component='input'
                                                className={errors.address && touched.address ? 'form-f-field with-error' : 'form-f-field'}
                                                type='text'
                                                placeholder='Address*'
                                                disabled={true}
                                                value={values.address}
                                            />
                                            {errors.address && touched.address ?
                                                (<div className='f-field-errors'>{errors.address}</div>) : null
                                            }

                                            <div className='flex--fields--holder'>
                                                <div className='flex-field-container'>
                                                    <label className='flex-form-label'>City*</label>
                                                    <Field
                                                        name='city'
                                                        component='input'
                                                        className={errors.city && touched.city ? 'form-f-field flex-with-error' : 'form-f-field'}
                                                        type='text'
                                                        placeholder='City*'
                                                        disabled={true}
                                                        value={values.city}
                                                    />
                                                    {errors.city && touched.city ?
                                                        (<div className='f-field-errors'>{errors.city}</div>) : null
                                                    }
                                                </div>

                                                {values.country === 'US' ?
                                                    <div className='flex-field-container'>
                                                        <label className='flex-form-label'>State*</label>
                                                        <Field name='state' component='select' disabled={true}
                                                               className='state-selector' placeholder='State'>
                                                            {usStateOpts.map(option => (
                                                                <option key={`state-${option.id}`}
                                                                        value={option.id}>
                                                                    {option.display}
                                                                </option>
                                                            ))}
                                                        </Field>
                                                        {errors.state && touched.state ?
                                                            (<div
                                                                className='f-field-errors'>{errors.state}</div>) : null
                                                        }
                                                    </div> :
                                                    <div className='flex-field-container'>
                                                        <label className='flex-form-label'>State*</label>
                                                        <Field name='state' component='select' disabled={true}
                                                               className='state-selector' placeholder='State'>
                                                            {usStateOpts.map(option => (
                                                                <option key={`state-${option.id}`}
                                                                        value={option.id}>
                                                                    {option.display}
                                                                </option>
                                                            ))}
                                                        </Field>
                                                        {errors.state && touched.state ?
                                                            (<div
                                                                className='f-field-errors'>{errors.state}</div>) : null
                                                        }
                                                    </div>
                                                }

                                                <div className='flex-field-container last'>
                                                    <label className='form-f-label'>Postal Code*</label>
                                                    <Field
                                                        name='postal'
                                                        component='input'
                                                        className={errors.postal && touched.postal ? 'form-f-field flex-with-error' : 'form-f-field'}
                                                        type='text'
                                                        placeholder='Postal Code*'
                                                        disabled={true}
                                                        value={values.postal}
                                                    />
                                                    {errors.postal && touched.postal ?
                                                        (<div className='f-field-errors'>{errors.postal}</div>) : null
                                                    }
                                                </div>
                                            </div>

                                            <label className='form-f-label'>Website*</label>
                                            <Field
                                                name='domain'
                                                component='input'
                                                className={errors.domain && touched.domain ? 'form-f-field with-error' : 'form-f-field'}
                                                type='text'
                                                placeholder='Website*'
                                                disabled={true}
                                                value={values.domain}
                                            />
                                            {errors.domain && touched.domain ?
                                                (<div className='f-field-errors'>{errors.domain}</div>) : null
                                            }

                                            <label className='form-f-label'>Business Type*</label>
                                            <Field name='business_type' component='select' disabled={true}
                                                   className='single-choice-selector'>
                                                {businessTypeOpts.map(option => (
                                                    <option key={`business_type-${option.id}`} value={option.id}>
                                                        {option.display}
                                                    </option>
                                                ))}
                                            </Field>
                                            {errors.business_type && touched.business_type ?
                                                (<div className='f-field-errors'>{errors.business_type}</div>) : null
                                            }

                                            {values.business_type === "" ?
                                                <div>
                                                    <label className='form-f-label'>Speciality*</label>
                                                    <Field name='speciality' component='select'
                                                           className='single-choice-selector disabled' disabled={true}>
                                                        {specArch.map(option => (
                                                            <option key={`speciality-${option.id}`} value={option.id}>
                                                                {option.display}
                                                            </option>
                                                        ))}
                                                    </Field>
                                                    {errors.speciality && touched.speciality ?
                                                        (<div
                                                            className='f-field-errors'>{errors.speciality}</div>) : null
                                                    }
                                                </div> :
                                                null
                                            }

                                            {values.business_type === 'architect' ?
                                                <div>
                                                    <label className='form-f-label'>Speciality*</label>
                                                    <Field name='speciality' component='select' disabled={true}
                                                           className='single-choice-selector'>
                                                        {specArch.map(option => (
                                                            <option key={`speciality-${option.id}`} value={option.id}>
                                                                {option.display}
                                                            </option>
                                                        ))}
                                                    </Field>
                                                    {errors.speciality && touched.speciality ?
                                                        (<div
                                                            className='f-field-errors'>{errors.speciality}</div>) : null
                                                    }
                                                </div> :
                                                null
                                            }

                                            {values.business_type === 'builder' ?
                                                <div>
                                                    <label className='form-f-label'>Speciality*</label>
                                                    <Field name='speciality' component='select' disabled={true}
                                                           className='single-choice-selector'>
                                                        {specBuilder.map(option => (
                                                            <option key={`speciality-${option.id}`} value={option.id}>
                                                                {option.display}
                                                            </option>
                                                        ))}
                                                    </Field>
                                                    {errors.speciality && touched.speciality ?
                                                        (<div
                                                            className='f-field-errors'>{errors.speciality}</div>) : null
                                                    }
                                                </div> :
                                                null
                                            }

                                            {values.business_type === 'designer' ?
                                                <div>
                                                    <label className='form-f-label'>Speciality*</label>
                                                    <Field name='speciality' component='select' disabled={true}
                                                           className='single-choice-selector'>
                                                        {specDesigner.map(option => (
                                                            <option key={`speciality-${option.id}`} value={option.id}>
                                                                {option.display}
                                                            </option>
                                                        ))}
                                                    </Field>
                                                    {errors.speciality && touched.speciality ?
                                                        (<div
                                                            className='f-field-errors'>{errors.speciality}</div>) : null
                                                    }
                                                </div> :
                                                null
                                            }

                                            {values.business_type === 'developer' ?
                                                <div>
                                                    <label className='form-f-label'>Speciality*</label>
                                                    <Field name='speciality' component='select' disabled={true}
                                                           className='single-choice-selector'>
                                                        {specDeveloper.map(option => (
                                                            <option key={`speciality-${option.id}`} value={option.id}>
                                                                {option.display}
                                                            </option>
                                                        ))}
                                                    </Field>
                                                    {errors.speciality && touched.speciality ?
                                                        (<div
                                                            className='f-field-errors'>{errors.speciality}</div>) : null
                                                    }
                                                </div> :
                                                null
                                            }

                                            {values.business_type === 'property_manager' ?
                                                <div>
                                                    <label className='form-f-label'>Speciality*</label>
                                                    <Field name='speciality' component='select' disabled={true}
                                                           className='single-choice-selector'>
                                                        {specPropMan.map(option => (
                                                            <option key={`speciality-${option.id}`} value={option.id}>
                                                                {option.display}
                                                            </option>
                                                        ))}
                                                    </Field>
                                                    {errors.speciality && touched.speciality ?
                                                        (<div
                                                            className='f-field-errors'>{errors.speciality}</div>) : null
                                                    }
                                                </div> :
                                                null
                                            }

                                            {values.business_type === 'remodeler' ?
                                                <div>
                                                    <label className='form-f-label'>Speciality*</label>
                                                    <Field name='speciality' component='select' disabled={true}
                                                           className='single-choice-selector'>
                                                        {specRemodeler.map(option => (
                                                            <option key={`speciality-${option.id}`} value={option.id}>
                                                                {option.display}
                                                            </option>
                                                        ))}
                                                    </Field>
                                                    {errors.speciality && touched.speciality ?
                                                        (<div
                                                            className='f-field-errors'>{errors.speciality}</div>) : null
                                                    }
                                                </div> :
                                                null
                                            }

                                            <label className='form-f-label'>Business Coverage</label>
                                            <Field name='business_coverage' component='select' disabled={true}
                                                   className='single-choice-selector'>
                                                {businessCoverageOpts.map(option => (
                                                    <option key={`business_coverage-${option.id}`} value={option.id}>
                                                        {option.display}
                                                    </option>
                                                ))}
                                            </Field>

                                            <h3 className='profile-data-section'>Project Information</h3>

                                            <label className='form-f-label'>Number of Projects/Year*</label>
                                            <Field
                                                name='project_information_numberOfProjects'
                                                component='input'
                                                className={errors.project_information_numberOfProjects && touched.project_information_numberOfProjects ? 'form-f-field with-error' : 'form-f-field'}
                                                type='number'
                                                placeholder='Number of Projects/Year*'
                                                disabled={true}
                                                value={values.project_information_numberOfProjects}
                                            />

                                            <label className='form-f-label'>Number of Homes/Projects*</label>
                                            <Field
                                                name='project_information_numberOfHomes'
                                                component='input'
                                                className={errors.project_information_numberOfHomes && touched.project_information_numberOfHomes ? 'form-f-field with-error' : 'form-f-field'}
                                                type='number'
                                                placeholder='Number of Homes/Projects*'
                                                disabled={true}
                                                value={values.project_information_numberOfHomes}
                                            />

                                            <label className='form-f-label'>Average Home Price *</label>
                                            <FormattedNumInput
                                                className={errors.project_information_averageHomePrice && touched.project_information_averageHomePrice ? 'form-f-field with-error' : 'form-f-field'}
                                                name='project_information_averageHomePrice'
                                                placeholder='$ 0.00'
                                                value={values.project_information_averageHomePrice}
                                                onChange={handleChange('project_information_averageHomePrice')}
                                                disabled={true}
                                            />

                                            <label className='form-f-label'>Primary Home Types *</label>
                                            <label className='second-f-label'>Select Options:</label>
                                            <div className='box--outline-comp'>
                                                <div className='checkbox-group-content'>
                                                    <FieldArray
                                                        name='project_information_primaryHomeTypes'
                                                        render={arrayHelpers => (
                                                            <div>
                                                                {homeTypeOpts.map(option => (
                                                                    <div key={option.id}>
                                                                        <input
                                                                            disabled={true}
                                                                            name='project_information_primaryHomeTypes'
                                                                            type='checkbox'
                                                                            value={option.id}
                                                                            checked={values.project_information_primaryHomeTypes.includes(option.id)}
                                                                            onChange={event => {
                                                                                if (event.target.checked) {
                                                                                    arrayHelpers.push(option.id);
                                                                                }
                                                                                else {
                                                                                    const idx = values.project_information_primaryHomeTypes.indexOf(option.id);
                                                                                    arrayHelpers.remove(idx);
                                                                                }
                                                                            }}
                                                                        /> {option.display}
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )}
                                                    />
                                                </div>
                                            </div>
                                            <div className='toggle-switch-gr'>
                                                <input
                                                    type='checkbox'
                                                    className='toggle--input--btn'
                                                    name='project_information_existingProjectToIncludeNoon'
                                                    checked={values.project_information_existingProjectToIncludeNoon}
                                                    readOnly={true}
                                                />
                                                <p className='toggle-in-label'>Do you have an existing project you would
                                                    like to include NOON on?</p>
                                            </div>

                                                <div>
                                                    <label className='form-f-label '>Project Size</label>
                                                    <Field name='project_information_projectSize' component='select'
                                                           className='single-choice-selector disabled' disabled={true}>
                                                        {projectSizeOpts.map(option => (
                                                            <option key={`project_information_projectSize-${option.id}`}
                                                                    value={option.id}>
                                                                {option.display}
                                                            </option>
                                                        ))}
                                                    </Field>

                                                    <label className='form-f-label'>Project Completion Date</label>
                                                    <DatePickerComponent
                                                        classStyle='form-f-field disabled'
                                                        id='project_information_projectCompletionDate'
                                                        value={values.project_information_projectCompletionDate}
                                                        onChange={setFieldValue}
                                                        greyed={true}
                                                        startDateValue={projCompliteD}
                                                        placeholderT='Project Completion Date'
                                                        canClear={false}
                                                    />
                                                </div>
                                            <br/>

                                            <div className='toggle-switch-gr'>
                                                <input
                                                    type='checkbox'
                                                    className='toggle--input--btn'
                                                    name='project_information_contactAboutExistingProject'
                                                    checked={values.project_information_contactAboutExistingProject}
                                                    readOnly={true}
                                                />
                                                <p className='toggle-in-label'>Would you like NOON to contact you to
                                                    help specify your project?</p>
                                            </div>
                                            <h3 className='profile-data-section'>Additional Information</h3>

                                            <label className='form-f-label'>How you heard about NOON?</label>
                                            <label className='second-f-label'>Select Options:</label>
                                            <div className='box--outline-comp'>
                                                <div className='checkbox-group-content'>
                                                    <FieldArray
                                                        name='additional_information_hearAboutNoon'
                                                        render={arrayHelpers => (
                                                            <div>
                                                                {refferalOpts.map(option => (
                                                                    <div key={option.id}>
                                                                        <input
                                                                            disabled={true}
                                                                            name='additional_information_hearAboutNoon'
                                                                            type='checkbox'
                                                                            value={option.id}
                                                                            checked={values.additional_information_hearAboutNoon.includes(option.id)}
                                                                            onChange={event => {
                                                                                if (event.target.checked) {
                                                                                    arrayHelpers.push(option.id);
                                                                                }
                                                                                else {
                                                                                    const idx = values.additional_information_hearAboutNoon.indexOf(option.id);
                                                                                    arrayHelpers.remove(idx);
                                                                                }
                                                                            }}
                                                                        /> {option.display}
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )}
                                                    />
                                                </div>
                                            </div>

                                            <h3 className='profile-data-section'>Refer Your Contractor</h3>

                                            <label className='form-f-label'>Company Name</label>
                                            <Field
                                                name='contractor_companyName'
                                                component='input'
                                                className='form-f-field'
                                                type='text'
                                                placeholder='Company Name'
                                                disabled={true}
                                                value={values.contractor_companyName}
                                            />

                                            <label className='form-f-label'>Primary Contact</label>
                                            <Field
                                                name='contractor_primaryContact'
                                                component='input'
                                                className='form-f-field'
                                                type='text'
                                                placeholder='Primary Contact'
                                                disabled={true}
                                                value={values.contractor_primaryContact}
                                            />

                                            <label className='form-f-label'>Primary Email</label>
                                            <Field
                                                name='contractor_primaryEmail'
                                                component='input'
                                                className={errors.contractor_primaryEmail && touched.contractor_primaryEmail ? 'form-f-field with-error' : 'form-f-field'}
                                                type='text'
                                                placeholder='Primary Email'
                                                disabled={true}
                                                value={values.contractor_primaryEmail}
                                            />
                                            <br/>
                                            <br/>
                                            <p className='dop-f-disclaimer'>* We will send an email inviting them to
                                                sign up for NOON Pro.</p>

                                            <h3 className='profile-data-section'>Refer Your Distributor</h3>

                                            <label className='form-f-label'>Company Name</label>
                                            <Field
                                                name='distributor_companyName'
                                                component='input'
                                                className='form-f-field'
                                                type='text'
                                                placeholder='Company Name'
                                                disabled={true}
                                                value={values.distributor_companyName}
                                            />

                                            <label className='form-f-label'>Primary Contact</label>
                                            <Field
                                                name='distributor_primaryContact'
                                                component='input'
                                                className='form-f-field'
                                                type='text'
                                                placeholder='Primary Contact'
                                                disabled={true}
                                                value={values.distributor_primaryContact}
                                            />

                                            <label className='form-f-label'>Primary Email</label>
                                            <Field
                                                name='distributor_primaryEmail'
                                                component='input'
                                                className={errors.distributor_primaryEmail && touched.distributor_primaryEmail ? 'form-f-field with-error' : 'form-f-field'}
                                                type='text'
                                                placeholder='Primary Email'
                                                disabled={true}
                                                value={values.distributor_primaryEmail}
                                            />

                                            <br/>
                                            <br/>
                                            <p className='dop-f-disclaimer'>* We will send an email inviting them to
                                                sign up for NOON Pro.</p>

                                        </Form>
                                    )}


                                </Formik>
                            }

                        </div>
                    </div> :
                    <Loader/>
                }
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/routes/UserProfile/DevArchProfile.js